import { IconBrandFacebook, IconBrandInstagram, IconBrandX, IconChevronLeft } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

type MessageModalProps = {
  onProceed: () => void
  show: boolean
  error?: string
  hashtag?: string
}

export const MessageModal = ({ show, error, onProceed, hashtag }: MessageModalProps) => {
  const { t } = useTranslation()

  const sanitizedHashtag = hashtag?.trim()

  const handleInstagram = () => {
    if (sanitizedHashtag) navigator.clipboard?.writeText(sanitizedHashtag).catch(() => {})
    if (!window.open('instagram://', '_blank')) {
      window.open('https://www.instagram.com/', '_blank')
    }
  }

  const handleX = () => {
    const text = sanitizedHashtag ? encodeURIComponent(sanitizedHashtag) : ''
    window.open(`https://x.com/intent/tweet?text=${text}`, '_blank')
  }

  const handleFacebook = () => {
    if (sanitizedHashtag) navigator.clipboard?.writeText(sanitizedHashtag).catch(() => {})
    window.open('https://www.facebook.com/', '_blank')
  }

  if (!show) return null

  return (
    <div className="fixed inset-0 z-[100] bg-white flex flex-col overflow-y-auto">
      {/* ヘッダー */}
      {/*<div className="relative flex items-center justify-center h-[44px] flex-shrink-0 border-b border-gray-100">*/}
      {/*  <button*/}
      {/*    type="button"*/}
      {/*    onClick={onProceed}*/}
      {/*    className="absolute left-2 flex items-center justify-center size-6"*/}
      {/*    aria-label={t('common.close', '閉じる')}*/}
      {/*  >*/}
      {/*    <IconChevronLeft size={24} className="text-black" />*/}
      {/*  </button>*/}
      {/*  <p className="font-bold text-[16px] text-black">AR PHOTO</p>*/}
      {/*</div>*/}

      <div className="flex-1 px-4 pt-6 pb-4">
        {/* タイトル */}
        <h2 className="font-bold text-[18px] text-black text-center mb-6">
          {error ? t('spot_detail.ar.save_error', '保存に失敗しました') : t('spot_detail.ar.saved', '保存しました')}
        </h2>

        {/* 説明テキスト */}
        <p className="text-[15px] text-black leading-relaxed mb-6">
          {error
            ? error
            : t(
                'spot_detail.ar.save_success_massage_main',
                '保存した写真、動画はお使いのスマートフォンに設定した保存先からご覧になれます。',
              )}
        </p>
        {!error && (
          <p className="text-[13px] text-[#757575] leading-relaxed mb-6">
            {t(
              'spot_detail.ar.save_success_massage_sub',
              '(iPhoneの場合は「ファイル」アプリ、Androidの場合は「ファイル管理アプリ」に保存されます)',
            )}
          </p>
        )}

        {/* SNSシェアカード */}
        {/*{!error && (*/}
        {/*  <div className="border border-[#FFC500] rounded-[8px] p-4 mb-4">*/}
        {/*    <p className="font-bold text-[16px] text-black text-center mb-4 leading-snug">*/}
        {/*      ハッシュタグをつけて*/}
        {/*      <br />*/}
        {/*      SNSに投稿しよう！*/}
        {/*    </p>*/}

        {/*    <div className="flex flex-col items-center gap-3">*/}
        {/*      <button*/}
        {/*        type="button"*/}
        {/*        onClick={handleInstagram}*/}
        {/*        className="flex items-center justify-center gap-2 h-[36px] w-[265px] rounded-[8px] border border-[#757575] bg-white font-bold text-[13px] text-[#757575]"*/}
        {/*      >*/}
        {/*        <IconBrandInstagram size={20} stroke={1.5} />*/}
        {/*        Instagramに投稿*/}
        {/*      </button>*/}
        {/*      <button*/}
        {/*        type="button"*/}
        {/*        onClick={handleX}*/}
        {/*        className="flex items-center justify-center gap-2 h-[36px] w-[265px] rounded-[8px] border border-[#757575] bg-white font-bold text-[13px] text-[#757575]"*/}
        {/*      >*/}
        {/*        <IconBrandX size={20} stroke={1.5} />*/}
        {/*        Xに投稿*/}
        {/*      </button>*/}
        {/*      <button*/}
        {/*        type="button"*/}
        {/*        onClick={handleFacebook}*/}
        {/*        className="flex items-center justify-center gap-2 h-[36px] w-[265px] rounded-[8px] border border-[#757575] bg-white font-bold text-[13px] text-[#757575]"*/}
        {/*      >*/}
        {/*        <IconBrandFacebook size={20} stroke={1.5} />*/}
        {/*        Facebookに投稿*/}
        {/*      </button>*/}
        {/*    </div>*/}

        {/*    /!*<p className="font-bold text-[13px] text-black text-center mt-4">{hashtag}</p>*!/*/}
        {/*    /!*<p className="text-[11px] text-[#757575] text-center mt-2 leading-[1.5]">*!/*/}
        {/*    /!*  ※ボタンをクリックするとハッシュタグなどがコピーされ*!/*/}
        {/*    /!*  <br />*!/*/}
        {/*    /!*  各種SNSアプリが起動します*!/*/}
        {/*    /!*</p>*!/*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>

      {/* 閉じるボタン */}
      <div className="flex justify-center pb-8 flex-shrink-0">
        <button
          type="button"
          onClick={onProceed}
          className="h-[48px] w-[123px] rounded-full bg-[#EEE] font-bold text-[15px] text-[#757575]"
        >
          {t('common.close', '閉じる')}
        </button>
      </div>
    </div>
  )
}
